"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Definition of the ObjectableMixin functino
 * @author Harris Lummis
 */

var changeCase_1 = require("@atlas/models/utils/changeCase");

var mapKeys_1 = __importDefault(require("lodash/mapKeys"));

var mapValues_1 = __importDefault(require("lodash/mapValues")); // A regex that matches a PascalCase string


exports.PASCAL_CASE_REGEX = /^[A-Z][a-z]+(?:[A-Z][a-z]+)*$/; // A regex that matches a simple CamelCase string

exports.CAMEL_CASE_REGEX = /^[a-z]+(?:[A-Z][a-z]+)*$/; // A regex that matches a simle SnakeCase string

exports.SNAKE_CASE_REGEX = /^[a-z]+(?:_[a-z]+)*$/;
/**
 * Determines if an object is an instance of the Objectable class
 * @param obj The object to check
 * @return True if the object is objectable
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any

function isObjectable(obj) {
  return typeof obj === 'object' && obj !== null && !!obj.isObjectable;
}

exports.isObjectable = isObjectable;
/** A class that adds object-related functionality to the base */

var Objectable =
/** @class */
function () {
  function Objectable() {
    /** Provides a means of ensuring that an instance is objectable */
    this.isObjectable = true;
  }

  Objectable.prototype.toObject = function (opts) {
    if (opts === void 0) {
      opts = {
        case: 'camel',
        dateType: 'date',
        onEmpty: 'leave'
      };
    }

    var targetCase = opts.case || 'camel';
    var dateType = opts.dateType || 'date';
    var onEmpty = opts.onEmpty || 'leave';
    var toDelete = [];

    if (dateType === 'date') {
      var dateValuesObject_1 = mapValues_1.default(this, function (v, k) {
        if (Array.isArray(v)) {
          return v.map(function (vEl) {
            return isObjectable(vEl) ? vEl.toObject(opts) : vEl;
          });
        }

        if (isObjectable(v)) {
          return v.toObject(opts);
        } // Schedule properties for deletion/nullification if necessary


        if (typeof v !== 'boolean' && !v) {
          if (onEmpty === 'omit') {
            toDelete.push(k);
            return;
          }

          if (onEmpty === 'nullify') {
            return null;
          }
        }

        return v;
      });
      toDelete.forEach(function (k) {
        delete dateValuesObject_1[k];
      });

      if (targetCase === 'camel') {
        return dateValuesObject_1;
      } else if (targetCase === 'pascal') {
        return mapKeys_1.default(dateValuesObject_1, function (_v, k) {
          return changeCase_1.pascalCase(k);
        });
      } else {
        return mapKeys_1.default(dateValuesObject_1, function (_v, k) {
          return changeCase_1.snakeCase(k);
        });
      }
    }

    var numericDatesObject = mapValues_1.default(this, function (v, k) {
      if (Array.isArray(v)) {
        return v.map(function (vEl) {
          return isObjectable(vEl) ? vEl.toObject(opts) : vEl instanceof Date ? vEl.getTime() : vEl;
        });
      }

      if (isObjectable(v)) {
        return v.toObject(opts);
      }

      if (v instanceof Date) {
        return v.getTime();
      } // Schedule properties for deletion/nullification if necessary


      if (typeof v !== 'boolean' && !v) {
        if (onEmpty === 'omit') {
          toDelete.push(k);
          return;
        }

        if (onEmpty === 'nullify') {
          return null;
        }
      }

      return v;
    });
    toDelete.forEach(function (k) {
      return delete numericDatesObject[k];
    });

    if (targetCase === 'camel') {
      return numericDatesObject;
    } else if (targetCase === 'pascal') {
      return mapKeys_1.default(numericDatesObject, function (_v, k) {
        return changeCase_1.pascalCase(k);
      });
    } else {
      return mapKeys_1.default(numericDatesObject, function (_v, k) {
        return changeCase_1.snakeCase(k);
      });
    }
  };

  return Objectable;
}();

exports.Objectable = Objectable;
exports.default = Objectable;